import React, { useState } from "react";
import { FaFacebookF, FaTwitter } from "react-icons/fa";
import { FaRegCircleCheck } from "react-icons/fa6";
import { IoChatbubbleEllipsesOutline } from "react-icons/io5";
import { MdDocumentScanner, MdPeopleAlt } from "react-icons/md";
import { Link } from "react-router-dom";
import FileUploader from "../fileUploader/FileUploader";

function General() {
  const [activeStep, setActiveStep] = useState(1);

  return (
    <div className="my_account general">
      <p className="text-center mt-4">
        "We do not store any of your information; it will solely be used for
        verification purposes and attached to your credit repair dispute
        letters"
      </p>
      <div className="tabs_area">
        <div className="steps">
          <button
            className={`step ${activeStep === 1 ? "active" : ""}`}
            onClick={() => setActiveStep(1)}
            disabled={false}
            aria-label="Step 1: Documents"
          >
            <MdDocumentScanner className="icons" /> Documents
          </button>
          <button
            className={`step ${activeStep === 2 ? "active" : ""}`}
            onClick={() => setActiveStep(2)}
            disabled={false}
            aria-label="Step 2: Refer a Friend"
          >
            <MdPeopleAlt className="icons" /> Refer a Friend
          </button>
        </div>
        <div className="step-container">
          <div className="step-content">
            {activeStep === 1 && (
              <>
                <div className="tabs_card">
                  <div className="header">
                    <h4>Proof of Identity</h4>
                  </div>
                  <div className="content">
                    <FileUploader btn_text="Browse" label="Upload file" />
                  </div>
                </div>
                <div className="tabs_card">
                  <div className="header">
                    <h4>Proof of Address</h4>
                  </div>
                  <div className="content">
                    <FileUploader btn_text="Browse" label="Upload file" />
                  </div>
                </div>
                <div className="tabs_card">
                  <div className="header">
                    <h4>Additional Documents (Optional)</h4>
                  </div>
                  <div className="content">
                    <FileUploader btn_text="Browse" label="Upload file" />
                  </div>
                </div>
              </>
            )}
            {activeStep === 2 && (
              <div className="tabs_card">
                <div className="content refer_content">
                  <FaRegCircleCheck className="icons" />
                  <h3>Refer a Friend, help them get a better Credit Score!</h3>
                  <div className="copy_input">
                    <input type="text" placeholder="Type your message" />
                    <button className="btn">Copy</button>
                  </div>
                  <div className="social_icons">
                    <Link className="icon_box">
                      <FaFacebookF className="icons" />
                    </Link>
                    <Link className="icon_box">
                      <FaTwitter className="icons" />
                    </Link>
                    <Link className="icon_box">
                      <IoChatbubbleEllipsesOutline className="icons" />
                    </Link>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default General;
